import { useState } from 'react';
import { flashStream, streamCats } from '@/mocks/homeData';

const INIT_COUNT = 6;

export default function FlashTimeline() {
  const [cat, setCat] = useState('全部');
  const [shown, setShown] = useState(INIT_COUNT);

  const filtered = cat === '全部' ? flashStream : flashStream.filter((f) => f.cat === cat);
  const visible = filtered.slice(0, shown);
  const hasMore = shown < filtered.length;

  return (
    <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
      <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-xs font-semibold tracking-[0.2em] text-primary-600">FLASH · 快讯流</p>
          <h3 className="mt-1 font-heading text-xl font-black text-foreground-950 md:text-2xl">实时快讯流</h3>
        </div>
        <div className="flex items-center gap-1.5 text-xs text-foreground-500">
          <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-primary-500"></span>
          今日已推送 {flashStream.length} 条
        </div>
      </div>

      <div className="mb-4 flex flex-wrap gap-1.5 rounded-full bg-background-50 p-1 md:w-fit">
        {streamCats.map((c) => (
          <button
            key={c}
            type="button"
            onClick={() => {
              setCat(c);
              setShown(INIT_COUNT);
            }}
            className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs transition-colors ${
              cat === c
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-600 hover:bg-background-200'
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      <ol className="relative flex-1 space-y-0 border-l border-background-300 pl-5">
        {visible.map((f, idx) => (
          <li key={f.id} className="relative pb-5 last:pb-0">
            <span className="absolute -left-[25px] top-1 flex h-2.5 w-2.5 items-center justify-center">
              <span
                className={`h-2 w-2 rounded-full ${
                  idx < 3 ? 'bg-accent-500' : 'bg-primary-300'
                }`}
              ></span>
            </span>
            <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
              <span className="font-mono text-[11px] font-semibold text-foreground-400">{f.time}</span>
              <span className="whitespace-nowrap rounded bg-accent-100 px-1.5 py-0.5 text-[11px] font-semibold text-accent-800">
                {f.cat}
              </span>
              <h4 className="text-sm font-bold text-foreground-950">
                <a href="#digest" className="hover:text-primary-700">
                  {f.title}
                </a>
              </h4>
            </div>
            <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{f.lead}</p>
          </li>
        ))}
      </ol>

      <div className="mt-5 border-t border-background-200 pt-4">
        {hasMore ? (
          <button
            type="button"
            onClick={() => setShown((s) => s + 4)}
            className="inline-flex w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100"
          >
            <i className="ri-arrow-down-s-line text-base" aria-hidden="true"></i>
            展开更多快讯
          </button>
        ) : (
          <p className="text-center text-xs text-foreground-400">已加载全部 · 共 {filtered.length} 条</p>
        )}
      </div>
    </div>
  );
}